module.exports = __webpack_public_path__ + "img/3diamond-01.64fa7db8.svg";